export default "__VITE_ASSET__DWxY$tGi__"